import { WizCommand, WizGroupCommand } from '@wizeoo/akm-component-lib';

import { VisionVO } from '@wizeoo/akm-compute-lib';
import { VISION_PROPERTY } from '../../model/enums';
import { Model } from '../../model/model';
import { UserContextService } from '../../manager/context/user-context.service';
import { BuCmd } from './bu/bu.cmd';
import { FindWeightGridCommand } from '../integration/find-wg.cmd';
import { FeatureCmd } from './feature/feature.cmd';
import { FindVisionCommand } from '../workingdata/find-vision.command';
import { RoleCmd } from '../user/role/role.cmd';
import { TabCmd } from '../workingzone/tab.cmd';

/**
 * commande de rechargement avant navig depuis la fallback
 * Author LMA
 */
export class ReloadCmd extends WizGroupCommand {

  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 

  private get _context(): UserContextService {
    return this.model.userContextService;
  }

  public calls: WizCommand<any>[] = [];
  public vision: VisionVO = null;

  /** chargement initial. Toute la BU */
  public prepareCalls(vision: VisionVO, callback: Function): ReloadCmd {
    this.vision = vision;

    if (!this.model.businessUnitEngine.currentBU) {
      this.calls.push(new BuCmd(this.model).get(this.model.domainCode, this.model.businessUnitCode)); // la BU cible
    }


    const buCode: string = this.model.businessUnitCode;
    const visCode: string = this.model.visionCode;
    if (!this._context.visionContextIsUp(buCode, visCode)) {
    // if (!usr.context.has(visCode)) {
      this.calls.push(this._context.loadUserContext());
    }

    if (!this.model.tabsCollection) {
      this.calls.push(new TabCmd(this.model).find());
    }

    if (!this.model.weightGridEngine.getWeightGridMap()) {
      this.calls.push(new FindWeightGridCommand(this.model));
    }

    if (!this.model.featureMap.has(this.model.businessUnitCode)) {
      this.calls.push(new FeatureCmd(this.model).find());
    }

    const targetVision: VisionVO = this.model.visionEngine.getVision(visCode);
    if (!!targetVision && this.model.visionEngine.getVisionProperties(targetVision, VISION_PROPERTY.ISCONFIGAPP)) { // app de conf, on vérifie que toutes les visions de la BU ont leur détail
      const vis: VisionVO[] = this.model.visionEngine.getCurrentBuVisions();
      let allLoaded: boolean = true;
      vis?.forEach((vi: VisionVO) => {
        if(!this.model.visionEngine.getVisionProperties(targetVision, VISION_PROPERTY.ISCONFIGAPP) 
          && !this.model.visionEngine.getVisionProperties(targetVision, VISION_PROPERTY.LOADED)) {
          allLoaded = false;
        }
        // console.log('bu vis', vi.code, vi.fullyLoaded);
      });

      if(!allLoaded) {
        this.calls.push(new FindVisionCommand(this.model).find()); // chargement complet de la vision
      }
      // console.log('targetVision', targetVision);

    } else {
      if(!targetVision || !this.model.visionEngine.getVisionProperties(targetVision, VISION_PROPERTY.LOADED)) {
        this.calls.push(new FindVisionCommand(this.model).find()); // chargement complet de la vision
      }
    }



    if (!this.model.rolesMap.has(this.model.businessUnitCode)) {
      this.calls.push(new RoleCmd(this.model).find());
    } 
    
    this.configure(this.calls,callback);
    return this;
  }

}
